import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ErrorCode,
  LogisticsCalculationPublishReadyContentSchema,
  type LogisticsCalculationDetail,
} from '@magimp/shared';
import { ApiClientError } from '../../../api/index.js';
import { Banner, Button } from '../../../ui/index.js';
import { usePublishLogisticsCalculation } from '../queries.js';

export function LogisticsCalculationPublishAction({
  calculation,
}: {
  calculation: LogisticsCalculationDetail;
}) {
  const { t } = useTranslation('logisticsCalculations');
  const publish = usePublishLogisticsCalculation(calculation.id);
  const [errorKey, setErrorKey] = useState<'publishNotReady' | 'publishError' | null>(null);
  const publishCalculation = () => {
    setErrorKey(null);
    if (!LogisticsCalculationPublishReadyContentSchema.safeParse(calculation.content).success) {
      setErrorKey('publishNotReady');
      return;
    }
    publish.mutate(undefined, {
      onError: (error) =>
        setErrorKey(
          error instanceof ApiClientError &&
            error.code === ErrorCode.LOGISTICS_CALCULATION_NOT_PUBLISH_READY
            ? 'publishNotReady'
            : 'publishError',
        ),
    });
  };
  return (
    <div className="rl-publish-action">
      {errorKey ? <Banner tone="error">{t(`editor.${errorKey}`)}</Banner> : null}
      <Button
        kind="primary"
        disabled={publish.isPending}
        data-testid="rl-publish"
        onClick={publishCalculation}
      >
        {t('actions.publish')}
      </Button>
    </div>
  );
}
